/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const SuperBadIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42 42' width='1em' height='1em' {...props}>
			<g data-name='Grupo 17702' fill={color}>
				<path
					data-name='Trazado 13530-6'
					d='M21 42a21 21 0 1 1 21-21 21 21 0 0 1-21 21Zm0-40.527A19.528 19.528 0 1 0 40.534 21 19.528 19.528 0 0 0 21 1.473Z'
				/>
				<path
					data-name='Trazado 13535'
					d='M13.52 30.385a.8.8 0 0 1-.8-.8.843.843 0 0 1 .03-.217 9.222 9.222 0 0 1 8.706-6.425 9.069 9.069 0 0 1 8.635 6.385.8.8 0 0 1-1.543.426 7.341 7.341 0 0 0-7.091-5.211 7.487 7.487 0 0 0-7.164 5.265.8.8 0 0 1-.773.577Z'
				/>
				<g data-name='Grupo 7481'>
					<path
						data-name='Trazado 13553'
						d='M9.094 20.552a.779.779 0 0 1-.5-1.472l4.138-1.768-3.68-2.67a.781.781 0 0 1 .915-1.266l5.9 4.285-6.664 2.849a.689.689 0 0 1-.109.042Z'
					/>
					<path
						data-name='Trazado 13554'
						d='M33.273 20.603a.831.831 0 0 1-.146-.051l-6.515-2.973 5.774-4.155a.78.78 0 1 1 .91 1.266l-3.595 2.588 4.073 1.858a.779.779 0 0 1-.5 1.467Z'
					/>
				</g>
			</g>
		</svg>
	)
}

export default SuperBadIcon
